import FJAppLeft from '../../../FJMainPreview/FJAppLeft/FJAppLeft';
import FJImageInputContainer from '../container/FJImageInputContainer';

const FJWatermarkRemoverLeft = () => {

    return (
        <FJAppLeft>
            <FJImageInputContainer />
        </FJAppLeft>
    );
};


export default FJWatermarkRemoverLeft; 